import Api from "./base/api-base";

export default class AchievementApi {
  info (construction_id, budget_id) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.achievement},
        {endpoint: Api.endpoint.construction, id: construction_id},
        {endpoint: Api.endpoint.budget, id: budget_id}
      ]
    });
  }
}